export enum RequestTypes {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
}
